<!--
 * @Description:  指定用户类型弹窗显示
 * @Author: ljrong
 * @Date: 2025-11-19 11:00:00
 * @LastEditors: ljrong
-->
<script setup lang="ts">
import { getIndexPopupConfig } from '@/api'
import { useWorkspaceStore, useUserStore } from '@/store'
import { Close } from '@vicons/carbon'
const workspaceStore = useWorkspaceStore()
const userStore = useUserStore()
const userId = computed(() => userStore.userInfo.id)
const workspaceId = computed(() => workspaceStore.currentWorkspace.workspaceId)
// 非付费用户
const isNoPayedUser = computed(() => workspaceStore.currentWorkspace.vipState === 0 || workspaceStore.currentWorkspace.vipState === 1)

/**
 * 展示逻辑
 * 1、用户是非付费用户
 * 2、getIndexPopupConfig 返回的 valid 为 true
 * 3、getIndexPopupConfig 返回的 image 不为空
 * 4、每个企业空间的用户，一天只能展示一次
 * 5、本地缓存判断当天是否展示过 规则为：indexPopupShow:${version}:${workspaceId}:${userId}:${date}:${image}
 */


const showModal = ref(false)
const popupImage = ref('')

// 接口获取是否展示引导
const getPopupConfig = async () => {
  const res = await getIndexPopupConfig<{ image: string, valid: boolean, version: string }>()
  const { image, valid, version } = res
  const date = new Date().toISOString().split('T')[0]
  const cacheKey = `indexPopupShow:${version}:${workspaceId.value}:${userId.value}:${image}:${date}`
  const cacheValue = localStorage.getItem(cacheKey)
  if (cacheValue) {
    return
  }
  localStorage.setItem(cacheKey, '1')

  if (valid && image) {
    showModal.value = true
    popupImage.value = image
  }
}

function closeModal() {
  showModal.value = false
  setTimeout(() => {
    popupImage.value = ''
  }, 500)
}

function clearOldCache() {
  const date = new Date().toISOString().split('T')[0]
  // 获取所有缓存key
  const cacheKeys = Object.keys(localStorage)
  cacheKeys.forEach((key) => {
    if (key.startsWith('indexPopupShow:')) {
      // 获取缓存key中的date, :分割的最后一个
      const cacheKeyList = key.split(':')
      const cacheDate = cacheKeyList[cacheKeyList.length - 1]
      if (cacheDate && cacheDate !== date) {
        localStorage.removeItem(key)
      }
    }
  })
}

function judgeShowPopupConfigImage() {
  if (isNoPayedUser.value) {
    clearOldCache()
    getPopupConfig()
  }
}

onMounted(() => {
  judgeShowPopupConfigImage()
})

watch(workspaceId, (oldValue, newValue) => {
  if (oldValue !== newValue) {
    judgeShowPopupConfigImage()
  }
})
</script>

<template>
  <NModal v-model:show="showModal" :mask-closable="false" :close-on-esc="false">
    <div class="new-user-notive-content">
      <img class="img" :src="popupImage" alt="new-user-notive" />
      <i class="close-icon" @click="closeModal">
        <NIcon :size="20" :component="Close" />
      </i>
    </div>
  </NModal>
</template>

<style lang="scss" scoped>
.new-user-notive-content {
  width: 450px;
  height: 534px;
  position: relative;

  .img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
}
</style>
